import 'js-autocomplete/auto-complete.css';
import autocomplete from 'js-autocomplete';
import $ from 'jquery';

const index_EE = document.getElementById('index_EE');
const archive = document.getElementById('archive');
const home = document.getElementById('home');

const autocompleteSearchEe = function() {
  if (index_EE) {
    const enterprises = JSON.parse(document.getElementById('search-data-ee').dataset.enterprises);
    const searchInput = document.getElementById('q');

    if (enterprises && searchInput) {
      new autocomplete({
        selector: searchInput,
        minChars: 1,
        source: function(term, suggest){
          term = term.toLowerCase();
          const choices = [];
          enterprises.forEach(function(etp) {
            choices.push(etp.name);
            choices.push(etp.address);
          });
          const matches = [];
          for (let i = 0; i < choices.length; i++) {
            if (~choices[i].toLowerCase().indexOf(term)) matches.push(choices[i]);
            suggest(matches);
          }
        },
      });
    };
  };
};


const autocompleteSearchPp = function() {
  if (home) {
    const pps = JSON.parse(document.getElementById('search-data-pp').dataset.pps);
    const sites = JSON.parse(document.getElementById('search-data-pp').dataset.sites);
    const enterprises = JSON.parse(document.getElementById('search-data-pp').dataset.enterprises);
    const users = JSON.parse(document.getElementById('search-data-pp').dataset.users);
    const intervenants = JSON.parse(document.getElementById('search-data-pp').dataset.intervenants);
    const searchInput = document.getElementById('q');

    if (pps && searchInput) {
      new autocomplete({
        selector: searchInput,
        minChars: 1,
        source: function(term, suggest){
          term = term.toLowerCase();
          const choices = [];
          pps.forEach(function(pp) {
            choices.push(pp.nom);
            choices.push(pp.status);
            choices.push(pp.created_at);
          })
          sites.forEach(function(site) {
            choices.push(site.name);
            choices.push(site.address);
          })
          enterprises.forEach(function(enterprise) {
            choices.push(enterprise.name);
            choices.push(enterprise.address);
          })
          users.forEach(function(user) {
            choices.push(user.name.toLowerCase());
            choices.push(user.email.toLowerCase());
          })
          intervenants.forEach(function(intervenant) {
            choices.push(intervenant.name);
          })
          const matches = [];
          // console.log(choices);
          for (let i = 0; i < choices.length; i++) {
            if (~choices[i].toLowerCase().indexOf(term))
              matches.push(choices[i]);
            suggest(matches);
          }
        },
      });
    }
  }
};

const autocompleteSearchPpArchives = function() {
  if (archive) {
    const pps = JSON.parse(document.getElementById('search-data-pp-archives').dataset.pps);
    const enterprises = JSON.parse(document.getElementById('search-data-pp-archives').dataset.enterprises);
    const users = JSON.parse(document.getElementById('search-data-pp-archives').dataset.users);
    const intervenants = JSON.parse(document.getElementById('search-data-pp-archives').dataset.intervenants);
    const searchInput = document.getElementById('q');

    if (pps && searchInput) {
      new autocomplete({
        selector: searchInput,
        minChars: 1,
        source: function(term, suggest){
          term = term.toLowerCase();
          const choices = [];
          pps.forEach(function(pp) {
            choices.push(pp.nom);
            choices.push(pp.status);
            choices.push(pp.created_at);
          })
          enterprises.forEach(function(enterprise) {
            choices.push(enterprise.name);
            choices.push(enterprise.address);
          })
          users.forEach(function(user) {
            choices.push(user.name);
            choices.push(user.email);
          })
          intervenants.forEach(function(intervenant) {
            choices.push(intervenant.name);
          })
          const matches = [];
          for (let i = 0; i < choices.length; i++) {
            if (~choices[i].toLowerCase().indexOf(term))
              matches.push(choices[i]);
            suggest(matches.uniq);
          }
        },
      });
    }
  }
};

export { autocompleteSearchEe, autocompleteSearchPp, autocompleteSearchPpArchives };
